import React from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { Welcome } from 'components/common/Welcome/Welcome'
import styles from '../../GMA/AbilityWelcome/AbilityWelcome.module.scss'
import PlayIcon from 'assets/icons/play.svg'
import { getPersonality, startPersonality } from 'ducks/respondent'
import { BoldButton } from 'components/shared/BoldButton/BoldButton'
import { t } from 'ttag'

const PersonalityWelcome = () => {
  const { totalQuestions } = useSelector(getPersonality, shallowEqual)
  const dispatch = useDispatch()

  return (
    <Welcome
      description={
        <div className={styles.description}>
          <div className={styles.paragraph}>
            {t`The personality test is used for the organization`}{' '}
            <b>{t`to get to know you.`}</b>{' '}
            {t`This gives the organization the opportunity to adapt the position to your strengths and needs.`}{' '}
            {t`There may be asked follow-up questions related to your results on the test during an interview.`}
          </div>
          <div className={styles.paragraph}>
            {t`It is therefore important that you`} <b>{t`respond honestly`}</b>{' '}
            {t`to the questions, and not adapt the answers to what you think the employer wants.`}
          </div>
          <div className={styles.paragraph}>
            {t`The test will start when you press “Start the test“.`}
          </div>
        </div>
      }
      totalQuestions={totalQuestions}
      time={t`No time limitation`}
      button={
        <BoldButton
          label={t`Start the test`}
          icon={PlayIcon}
          isIconFirst
          onClick={() => dispatch(startPersonality())}
        />
      }
    />
  )
}

export default PersonalityWelcome
